/* Rollin'Denims · ops engine hooks v1
   - copies every site form and every notify-me request to the Ops engine (Google Apps Script)
   - shows a "code applied" bar when someone lands from a referral or creator link */
(function () {
  'use strict';
  var URL_ = window.RD_ENGINE || '';
  var beacon = function (obj) {
    if (!URL_ || !navigator.sendBeacon) return;
    try { navigator.sendBeacon(URL_, new Blob([JSON.stringify(obj)], { type: 'text/plain' })); } catch (x) {}
  };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };

  /* site forms (contact, creators, dealers, returns...) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('[data-rdp-form]')) {
      var hp = f.querySelector('[name="rd_hp"]'); if (hp && hp.value) return;
      var fields = {};
      f.querySelectorAll('[name^="contact["]').forEach(function (el) {
        var k = el.name.slice(8, -1); if (k === 'Form' || k === 'Reference') return;
        fields[k] = el.type === 'checkbox' ? (el.checked ? 'Yes' : '') : (el.value || '').trim();
      });
      if (f.__rdEng) return; f.__rdEng = true; setTimeout(function () { f.__rdEng = false; }, 4000);
      beacon({ action: 'form', form: f.getAttribute('data-rdp-name') || document.title, fields: fields, page: location.pathname });
      return;
    }
    if (f.matches('.rd-nm__form')) {
      var g = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; };
      var email = g('email'), name = g('rname');
      if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return;
      var isReq = !f.querySelector('[data-nm-sizerow]').hidden;
      var form = document.querySelector('form[data-type="add-to-cart-form"]');
      var sel = form && (form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]'));
      var variants = []; try { variants = JSON.parse((document.querySelector('.pr_variants_json') || {}).textContent || '[]'); } catch (x) {}
      var v = null; for (var i = 0; i < variants.length; i++) if (sel && String(variants[i].id) === String(sel.value)) v = variants[i];
      var cfg = {}; try { cfg = JSON.parse(document.getElementById('rd-pdp-config').textContent); } catch (x) {}
      beacon({
        action: 'notify', type: isReq ? 'size_request' : 'notify_me', name: name, email: email,
        wa: g('wa').replace(/[^\d+]/g, ''), when: g('when'), size: isReq ? g('size') : '',
        product: (cfg.jeansName || cfg.title || document.title).trim(), variant: v && v.title !== 'Default Title' ? v.title : '',
        sku: !isReq && v ? (v.sku || '') : '', variantId: !isReq && v ? String(v.id) : ''
      });
    }
  }, true);

  /* "code applied" bar */
  var bar = function () {
    var m = document.cookie.match(/(?:^|; )discount_code=([^;]+)/); if (!m) return;
    var code = decodeURIComponent(m[1]).toUpperCase();
    if (!code || /^RIDE-SYS/.test(code) || document.querySelector('[data-rdr]')) return;
    try { if (sessionStorage.getItem('rd_bar_x') === code) return; } catch (x) {}
    var ride = code.indexOf('RIDE-') === 0, who = ride ? (code.split('-')[1] || '') : '';
    var st = document.createElement('style');
    st.textContent = '.rd-codebar{position:relative;z-index:50;display:flex;align-items:center;justify-content:center;background:#0057ec;color:#fff;font-family:var(--rd-body,Ubuntu,Arial,sans-serif);font-size:13.5px;line-height:1.4;padding:10px 44px 10px 16px;text-align:center}.rd-codebar b{font-family:var(--rd-head,Montserrat,Arial,sans-serif);font-weight:700}.rd-codebar button{all:unset;position:absolute;right:10px;top:50%;transform:translateY(-50%);width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:20px;cursor:pointer;color:#fff}.rd-codebar button:focus-visible{outline:2px solid #fff}';
    document.head.appendChild(st);
    var el = document.createElement('div');
    el.className = 'rd-codebar'; el.setAttribute('role', 'status');
    el.innerHTML = '<span>' + (ride
      ? '<b>₹500 off is applied.</b> ' + (who ? esc(who.charAt(0) + who.slice(1).toLowerCase()) + ' sent you. ' : '') + 'It comes off at checkout on orders of ₹3,000+.'
      : '<b>' + esc(code) + ' is applied.</b> Your discount comes off at checkout.') + '</span><button type="button" aria-label="Close">×</button>';
    document.body.insertBefore(el, document.body.firstChild);
    el.querySelector('button').addEventListener('click', function () { el.remove(); try { sessionStorage.setItem('rd_bar_x', code); } catch (x) {} });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bar); else bar();

  /* where this visitor came from: first and last touch, tied to the cart so the order shows its source */
  var ls = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (x) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (x) {} }
  };
  var touch = function () {
    var q; try { q = new URLSearchParams(location.search); } catch (x) { return; }
    var host = ''; try { if (document.referrer) host = new URL(document.referrer).hostname.replace(/^www\./, ''); } catch (x) {}
    if (host === location.hostname.replace(/^www\./, '') || /myshopify\.com$|gokwik/.test(host)) host = '';
    var s = '', m = '';
    if (q.get('utm_source')) { s = q.get('utm_source'); m = q.get('utm_medium') || ''; }
    else if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) { s = 'google'; m = 'cpc'; }
    else if (q.get('fbclid')) { s = /instagram/.test(host) ? 'instagram' : 'facebook'; m = 'click'; }
    else if (host) {
      if (/google\.|bing\.|duckduckgo|yahoo\./.test(host)) { s = host.split('.')[0] === 'm' ? host.split('.')[1] : host.split('.')[0]; m = 'organic'; }
      else if (/instagram|facebook|fb\.|youtube|t\.co$|twitter|x\.com|linkedin|reddit|whatsapp/.test(host)) { s = host.replace(/^(l|lm|m)\./, '').split('.')[0]; m = 'social'; }
      else { s = host; m = 'referral'; }
    }
    var now = new Date().toISOString().slice(0, 10);
    var t = ls.get('rd_touch') || { n: 0 };
    var seen = false; try { seen = sessionStorage.getItem('rd_seen') === '1'; sessionStorage.setItem('rd_seen', '1'); } catch (x) {}
    if (!seen) t.n = (t.n || 0) + 1;
    if (s) {
      var hit = { s: s.slice(0, 60), m: m.slice(0, 60), c: (q.get('utm_campaign') || '').slice(0, 100), ct: (q.get('utm_content') || '').slice(0, 100), l: location.pathname.slice(0, 120), r: host, d: now };
      if (!t.f) t.f = hit;
      t.l = hit;
    } else if (!t.f && !seen) {
      t.f = { s: 'direct', m: '', c: '', ct: '', l: location.pathname.slice(0, 120), r: '', d: now };
    }
    ls.set('rd_touch', t);
    return t;
  };
  var T = touch();
  /* ad click ids for Meta and Google, so every order carries what's needed to match it back to the ad */
  var ckv = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? decodeURIComponent(m[1]) : ''; };
  var ids = (function () {
    var q; try { q = new URLSearchParams(location.search); } catch (x) { q = { get: function () { return null; } }; }
    var k = ls.get('rd_ids') || {}, now = Date.now(), fbclid = q.get('fbclid'), gclid = q.get('gclid') || q.get('gbraid') || q.get('wbraid');
    if (fbclid && fbclid !== k.fbclid) { k.fbclid = fbclid.slice(0, 500); k.fbc = 'fb.1.' + now + '.' + k.fbclid; }
    if (gclid) k.gclid = gclid.slice(0, 200);
    var cfbc = ckv('_fbc'); if (cfbc && !fbclid) k.fbc = cfbc;
    var cfbp = ckv('_fbp'); if (cfbp) k.fbp = cfbp;
    ls.set('rd_ids', k);
    return k;
  })();
  var idAttrs = function () {
    var a = {}, fbp = ckv('_fbp') || ids.fbp;
    if (ids.fbc) a._fbc = ids.fbc;
    if (fbp) a._fbp = fbp;
    if (ids.gclid) a._gclid = ids.gclid;
    return a;
  };
  var str = function (h) { return h ? [h.s, h.m, h.c, h.ct].filter(Boolean).join(' / ') + ' @ ' + h.l + ' (' + h.d + ')' : ''; };
  var syncing = false;
  var sync = function () {
    if (!T || syncing) return;
    syncing = true;
    /* runs on every visit, not only once something is in the cart, so a straight "Buy now" order carries it too */
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.token) return;
      var attrs = { _rd_first: str(T.f), _rd_last: str(T.l || T.f), _rd_visits: String(T.n || 1) }, ia = idAttrs();
      for (var k in ia) attrs[k] = ia[k];
      var sig = cart.token + '|' + JSON.stringify(attrs);
      if (ls.get('rd_touch_sent') === sig) return;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
        .then(function () { beacon({ action: 'touch', cart: cart.token, first: T.f || null, last: T.l || T.f || null, visits: T.n || 1 }); ls.set('rd_touch_sent', sig); });
    }).catch(function () {}).then(function () { syncing = false; });
  };
  setTimeout(sync, 1200); setTimeout(sync, 5000);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"], button[data-atc-form], [data-rd-s-btn], [data-rd-s-buy], [data-rd-addon-add], .t4s-pr__atc, .gokwik-checkout button, .gokwik-marge, button[name="checkout"]');
    if (b) { sync(); setTimeout(sync, 2500); setTimeout(sync, 6000); }
  }, true);

  /* ₹ instead of "Rs. 4,995.00" wherever the theme prints a price */
  var RS = /Rs\.\s?(\d[\d,]*)(\.(\d\d))?/g;
  var fix = function (root) {
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) { return n.nodeValue.indexOf('Rs.') > -1 && !(n.parentNode && /SCRIPT|STYLE|TEXTAREA|INPUT/.test(n.parentNode.nodeName)) ? 1 : 3; } });
    var n, list = []; while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(RS, function (_, a, b, c) { return '₹' + a + (c && c !== '00' ? '.' + c : ''); }); });
  };
  var start = function () {
    fix(document.body);
    if (!window.MutationObserver) return;
    var pending = [], queued = false;
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { pending.push(m.type === 'characterData' ? m.target.parentNode : m.target); });
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; var p = pending; pending = []; p.forEach(function (el) { if (el && el.isConnected) fix(el); }); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
